import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RotateObjectService {

  public additionalRotate = 0;
  private center = null;
  get centerPos(){
    return this.center;
  }
  private currentAngle = null;
  private handleOffsetFromCenter = 60;
  private _centerUpdated$ = new Subject();
  private _hideRotateHandler$ = new Subject();
  get hideRotateHandler$(){
    return this._hideRotateHandler$.asObservable();
  }

  private _rotateStart$ = new BehaviorSubject(false);
  set rotateStart(val:boolean){
    this._rotateStart$.next(val)
  }
  get isRotating(){
    return this._rotateStart$.asObservable()
  }

  private finishCb = null;
  private _objectRotated$ = new Subject<any>();
  get objectRotated$(){
    return this._objectRotated$.asObservable();
  }
  set objectRotated(val){
    this.currentAngle = val;
    this._objectRotated$.next(val);
  }
  get centerUpdated$(){
    return this._centerUpdated$.asObservable();
  }

  constructor() { }

  objectOutsideRotated(degrees){
    this.setObjectCenter(this.center, degrees);
  }

  //update data on server
  endDragging(){
    this.rotateStart = false;
    if (this.finishCb){
      this.finishCb(this.currentAngle);
    }
  }

  hideRotateHandler(){
    this._hideRotateHandler$.next(true);
  }

  clearRotateEndCb(){
    this.finishCb = null;
  }

  setCb(cb){
    this.finishCb = cb;
  }

  setObjectRotateCenterAndOffset(center, rotate, offset?){
    if (offset){
      this.handleOffsetFromCenter = offset;
    }
    this.setObjectCenter(center, rotate);
  }

  setObjectCenter(center, rotate?){
    this.center = center;
    if (rotate != null && rotate != 'undefined'){
      this.currentAngle = rotate;
    }
    this._centerUpdated$.next({center: this.center, offset: this.handleOffsetFromCenter, rotate: (this.currentAngle || 0)-this.additionalRotate});
  }

  getRotationFromMousePosition (mousePosition) {
    var mouseX = mousePosition.x - this.center.x;
    var mouseY = mousePosition.y - 64 - this.center.y;

    var d1 = mouseX;
    var d2 = Math.sqrt(Math.pow(mouseX, 2) + Math.pow(mouseY, 2));
    var sin = d1 / d2;
    var angle = Math.asin(sin);
    if (mouseY > 0) {
      angle = Math.PI - angle;
    }
    return angle;
  };

  getHandlePositionFromAngle(angle) {
    return {
      x: this.center.x + this.handleOffsetFromCenter * Math.sin(angle),
      y: this.center.y - this.handleOffsetFromCenter * Math.cos(angle)
    };
  };
}
